import React from 'react';
import { useResponsive } from '../../../hooks/useResponsive';

interface OrderCompletionInfoProps {
  form: any;
}

const UserUploadedPhoto: React.FC<OrderCompletionInfoProps> = ({ form }) => {
  const { isMobile } = useResponsive();

  const items = form?.orderServices?.filter(e => !e.isAddOn && (e.media || e.pinterest || e.service?.hasMedia));

  if (!items?.length) {
    return null;
  }

  return (
    <section className="completion-info">
      {items.map(e =>
        <div className="bottom width100" key={e.id}>
          <h6 className="dashBoardTitle">عکس آپلود شده برای {e.service?.title}</h6>
          {e.media?.url ? (
            <a href={e.media.url} target="_blank" rel="noreferrer">
              <img
                className={`orderFinalImage ${isMobile ? 'mobile-image' : ''}`}
                src={e.media.url}
                alt="عکس آپلود شده"
                loading="lazy"
              />
            </a>
          ) : e.service?.hasMedia && <p className="missingMedia">مشتری برای این خدمت عکسی آپلود نکرده است</p>}
          {e.pinterest && <a href={e.pinterest} target='_blank' rel="noreferrer">لینک پینترست</a>}
        </div>
      )}
    </section>
  );
};

export default UserUploadedPhoto;
